module.exports = global["_"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ../_mrk_src/~/expose-loader?_!../_mrk_src/~/lodash/index.js
// module id = 5
// module chunks = 0 1